import React from "react";
import Price from "./price";
import { Link } from "react-router-dom";
import { PlayerStore, Store } from "../store";
import useWantlist from "../hooks/useWantlist";
import { useDefaultImage } from "../hooks/useInventory";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Tile = ({ item }) => {
  const config = Store.useState(s => s.config);
  const forSaleListings = item.listings ? item.listings.filter(l => l.stock.quantity > 0) : [];
  const cheapest = forSaleListings.length ? forSaleListings[0] : null;
  const defaultImage = useDefaultImage();
  const wantlistEnabled = config.eshop.theme.selected.settings?.wantlist?.enabled;

  if (item.type === "ReleaseItem")
    return <ReleaseTile item={item} config={config} defaultImage={defaultImage} cheapest={cheapest} listings={forSaleListings} wantlistEnabled={wantlistEnabled} />;

  else if (item.type === "ProductItem")
    return <ProductTile item={item} defaultImage={defaultImage} cheapest={cheapest} listings={forSaleListings} wantlistEnabled={wantlistEnabled} />;

  else if (item.type === "BookItem")
    return <BookTile item={item} defaultImage={defaultImage} cheapest={cheapest} listings={forSaleListings} wantlistEnabled={wantlistEnabled} />;
};

const ReleaseTile = ({ item, config, cheapest, defaultImage, wantlistEnabled }) => {
  const { addToWantlist } = useWantlist();
  const path = item.path;
  const { loadTracklist, currentTrackData, isPlaying, playPauseTrack } = PlayerStore.useState(s => s);

  const buttonIsPlaying = isPlaying && currentTrackData && currentTrackData.release._id === item._id;
  const active = config.eshop.theme.selected.player?.active;

  const tracklistToLoad = {
    tracklist: item.data.tracklist.filter(t => t.uri).map(t => ({ track: t, release: item })) || [],
    playOffset: 0
  };

  return (<div className='tile releaseItem'>
    <Link to={path} className="artwork">
      <LazyLoadImage src={item.data?.images[0]?.uri || defaultImage} />
    </Link>
    <div className="priceAndActions">
      <PriceAndSecondHandSection listing={cheapest} />
      <div className="actions">
        {active && item.data.tracklist.filter(t => t.uri).length ? <button type="button" onClick={e => buttonIsPlaying ? playPauseTrack() : loadTracklist(tracklistToLoad)}>
          <i className={`cg-icon-${buttonIsPlaying ? "pause" : "play"}`} />
        </button> : null}
        {wantlistEnabled ? <button type="button" onClick={e => addToWantlist(item)}>
          <i className={item.wanted ? "cg-icon-wantlist-fill" : "cg-icon-wantlist"}/>
        </button> : null }
      </div>
    </div>
    <ArtistNames artists={item.data.artists} />
    <Link to={path}>{item.data.title}</Link>
  </div>);
};

export function ArtistNames (props) {
  return (
    <p className='artists'>
      {props.artists.map((a, index) => (
        <span key={index + a.name}>
          {a.id ? <Link to={`/catalogue?artists=${a.id}`}>{a.anv || a.name} </Link> : `${a.anv || a.name}`}
        </span>
      ))}
    </p>
  );
}

const PriceAndSecondHandSection = ({ listing }) => {
  return <p className="price">
    {listing ? <Price listing={listing} /> : "N/A"}
    {listing?.prices.compare ? <Price className="discounted" value={listing.prices.compare} /> : null}
    {listing?.secondHand ? <span className="secondHand"></span> : null}
  </p>;
};

const ProductTile = ({ item, cheapest, defaultImage, wantlistEnabled }) => {
  const { addToWantlist } = useWantlist();

  const path = item.path;

  return (<div className='tile productItem'>
    <Link to={path}>
      <LazyLoadImage src={item.data?.images[0]?.uri || defaultImage} />
    </Link>
    <div className="priceAndActions">
      <PriceAndSecondHandSection listing={cheapest} />
      <div className="actions">
        { wantlistEnabled ? <button type="button" onClick={e => addToWantlist(item)}>
          <i className={item.wanted ? "cg-icon-wantlist-fill" : "cg-icon-wantlist"}/>
        </button> : null }
      </div>
    </div>
    <Link to={path}>{item.data.title}</Link>
  </div>);
};

const BookTile = ({ item, cheapest, defaultImage, wantlistEnabled }) => {
  const { addToWantlist } = useWantlist();

  const path = item.path;

  return (<div className='tile productItem'>
    <Link to={path}>
      <LazyLoadImage src={item.data?.images[0]?.uri || defaultImage} />
    </Link>
    <div className="priceAndActions">
      <PriceAndSecondHandSection listing={cheapest} />
      <div className="actions">
        {wantlistEnabled ? <button type="button" onClick={e => addToWantlist(item)}>
          <i className={item.wanted ? "cg-icon-wantlist-fill" : "cg-icon-wantlist"}/>
        </button> : null}
      </div>
    </div>
    <Link to={path}>{item.data.title} {item.data.subtitle ? <span>-{item.data.subtitle}</span> : null}</Link>
  </div>);
};

export { Tile };
